import React from "react";

function QuotedConfigurationDetails({ data }) {
  
  // console.log("Dataaaaaaaa")
  // console.log(data )
  const applySetupAndRunPercentage = (price) => {
    return data.ToggleValue === "Net"
      ? (price || 0) * data.netSetupAndRunPercentage
      : price || 0;
  };
  const getLocationData = () => {
    const decoData1 = data?.decoData?.filter(
      (d) => d.name === data.selectedDeco1
    )[0];
    const decoData2 = data?.decoData?.filter(
      (d) => d.name === data.selectedDeco2
    )[0];

    const locationsData = [
      {
        title: "Location 1",
        deco: decoData1,
        color: data.productColorsInputValue1 || "",
        setupCharge: `$${applySetupAndRunPercentage(data.setupPrice1).toFixed(3)}`,
        netcolor: data.DisplayColor1,
        runCharge: `$${applySetupAndRunPercentage(data.Runcharge1).toFixed(3)}`,
        stitchCount: data.stitchCountLoc1,
      },
    ];

    //(only display when Locations >1)
    if (
      data.selectedArtChoice == "false" &&
      data.productLocationInputValue == 2
    )
      locationsData.push({
        title: "Location 2",
        deco: decoData2,
        color: data.productColorsInputValue2 || "",
        setupCharge: `$${applySetupAndRunPercentage(data.setupPrice2).toFixed(3)}`,
        netcolor: data.DisplayColor2,
        runCharge: `$${applySetupAndRunPercentage(data.Runcharge2).toFixed(3)}`,
        stitchCount: data.stitchCountLoc2,
      });

    return locationsData;
  };

  const Location = ({ value }) => {
    if (!value) return <div />;

    return (
      <div>
        <div className="font-weight-bolder mt-1">{value.title}</div>
        <div className="table-responsive mt-4">
          <table className="table table-vertical-center text-white">
            <tbody>
              <tr>
                <td className="text-left">Deco Method :</td>
                <td className="text-right">
                  {value.deco?.hyphanateName || ""}
                </td>
              </tr>
              {value.deco?.name?.toLowerCase() === "embroidery" && (
                <tr>
                  <td className="text-left">Stitch Count :</td>
                  <td className="text-right">{value.stitchCount || ""}</td>
                </tr>
              )}
              <tr>
                <td className="text-left">Number of Colors :</td>
                <td className="text-right">{value.color + " ( Net: " + value.netcolor + ")" || ""}</td>
              </tr>
              <tr>
                <td className="text-left font-weight-bold">Setup :</td>
                <td className="text-right">{value.setupCharge || ""}</td>
              </tr>
              <tr>
                <td className="text-left font-weight-bold">Run :</td>
                <td className="text-right">{value.runCharge || ""}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  if (!data) return <div />;
  return (
    <div>
      <div className="border border-white"></div>
      <div className="font-weight-bolder mt-5">
        <h5>Quoted Configuration Details</h5>
      </div>
      <div className="table-responsive mt-4">
        <table className="table table-vertical-center text-white">
          <tbody>
            <tr>
              <td className="text-left">Item Number :</td>
              <td className="text-right">
                {data?.selectedProductDetails?.itemCode || ""}
              </td>
            </tr>
            <tr>
              <td className="text-left">Deco Locations per Item :</td>
              <td className="text-right">
                {data?.productLocationInputValue || ""}
              </td>
            </tr>
            {data.selectedArtChoice === "false" && (
              <tr>
                {/*  (only display when Locations >1) */}
                <td className="text-left">Art Same/Different :</td>
                <td className="text-right">
                  {data.selectedArtChoice === "true" ? "Same" : "Different"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {getLocationData()?.map((value, i) => (
        <Location value={value} key={i} />
      )) || ""}
    </div>
  );
}

export default QuotedConfigurationDetails;
